import { StatusQueryStatus } from '../enums';

export const StatusQueryStatuses = [
  { name: 'Open', value: StatusQueryStatus.Open },
  { name: 'Partly Open', value: StatusQueryStatus.PartlyOpen },
  { name: 'Closed', value: StatusQueryStatus.Closed },
];
